import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { CollectorModel } from '@admin/modules/collectors/model/collectors.model';
import { GET_COLLECTORS } from './collector.GraphQL';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CollectorService {
  constructor(private apollo: Apollo) {}

  getCollectorsByTenant(tenantId: string): Observable<CollectorModel[]> {
    return this.apollo
      .query<{ searchCollectors: CollectorModel[] }>({
        query: GET_COLLECTORS,
        variables: { tenantId },
      })
      .pipe(map((res) => res.data?.searchCollectors ?? []));
  }
}
